import _DatePicker from "hzero-ui/lib/date-picker";
import { getRequiredInputComponent } from "../Input";
import "./css";
var RangePicker = _DatePicker.RangePicker,
  WeekPicker = _DatePicker.WeekPicker,
  MonthPicker = _DatePicker.MonthPicker,
  YearPicker = _DatePicker.YearPicker;
var DatePicker = getRequiredInputComponent(_DatePicker, "t-datepicker");
DatePicker.RangePicker = getRequiredInputComponent(RangePicker, "t-datepicker");
DatePicker.WeekPicker = getRequiredInputComponent(WeekPicker, "t-datepicker");
DatePicker.MonthPicker = getRequiredInputComponent(MonthPicker, "t-datepicker");
DatePicker.YearPicker = getRequiredInputComponent(YearPicker, "t-datepicker");
export default DatePicker;